<div class="sdp-policy-edit-container">
	<div
		class="sdp-policy-edit-skeleton"
		*ngIf="!dataLoaded; else formField"
	>
		<div></div>
		<div></div>
	</div>
	<ng-template #formField>
		<div class="sdp-policy-edit-form-container">
			<div class="policy-input sdp-policy-edit-form-select">
				<p-listbox
					[options]="accessData"
					[(ngModel)]="selectedAccessData"
					multiple="multiple"
					checkbox="checkbox"
					filter="filter"
					optionLabel="label"
					[showToggleAll]="false"
				>
					<p-header>
						{{ "policy.wizard.edit.select-list" | translate }}
					</p-header>
					<ng-template
						let-access
						pTemplate="item"
					>
						{{shortenPhrase(access.label, 22)}}
						<span class="sdp-policies-icon-type-container">
							<span class="sdp-policies-icon">
								<sdp-icon [icon]="access.value.type === 'alias' ? iconSaml : iconUser"></sdp-icon>
							</span>
						</span>
					</ng-template>
				</p-listbox>
				<button
					mat-icon-button
					(click)="showCreateSamlAlias()"
					class="sdp-icon-button-icon sdp-policy-create-samlalias-button"
					matTooltip="{{ 'policy.wizard.add.samlAlias.text' | translate }}"
					[matTooltipPosition]="'above'"
					[matTooltipShowDelay]="1000"
					[disabled]="!hasIdp"
				>
					<sdp-icon [icon]="addIcon"></sdp-icon>
					<span class="sdp-policy-create-samlalias-button-text">{{ 'policy.wizard.add.samlAlias.text' | translate }}</span>
				</button>
			</div>
		</div>
		<div class="policy-display">
			<mat-card>
				<mat-card-header style="height:30px;">
					{{ "policy.wizard.edit.display-list" | translate }}
				</mat-card-header>
				<mat-card-content class="sdp-policy-edit-card-content">
					<div *ngFor="let c of selectedAccessData">
						<div
							[matTooltip]="c.label"
							matTooltipClass="sdp-custom-tooltip"
							class="sdp-administrative-role-tag"
						>{{ shortenPhrase(c.label,22) }}</div>
					</div>
					<span class="sdp-policy-edit-card-empty" *ngIf="selectedAccessData.length == 0">
						{{ 'policy.wizard.selectedAccessData.empty' | translate }}
					</span>
				</mat-card-content>
			</mat-card>
		</div>
	</ng-template>
</div>